import { useState, useEffect } from "react";

function ErrorBoundary({ children }) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const errorHandler = (error, errorInfo) => {
      console.error("Error caught by Error Boundary:", error, errorInfo);
      setHasError(true);
    };

    window.onerror = (message, source, lineno, colno, error) => {
      errorHandler(error);
    };

    window.onunhandledrejection = (event) => {
      errorHandler(event.reason);
    };

    return () => {
      window.onerror = null;
      window.onunhandledrejection = null;
    };
  }, []);

  if (hasError) {
    return <h2>Something went wrong. Please refresh the page.</h2>;
  }

  return children;
}

export default ErrorBoundary;
